<template>
  <div class="col-80 filtre-resultats" :class="authenticated && hasActiveSubscription ? '' : 'min-h-100'">
    <template v-if="products.results && products.results.length">
      <subscription-ad-card> </subscription-ad-card>
      <pagination-item
        class="-mt-4 -mb-2"
        :items="products"
        :page="page"
        @changePage="
          $emit('update:page', $event)
          $emit('changePage')
        "
      ></pagination-item>
      <template v-for="(item, index) in products.results">
        <products-listing-row
          :key="index" 
          :item="item"
          :routeNameToDetail="routeNameToDetail"
          :favorite="favorite"
          @favorite-removed="$emit('favorite-removed')"
          :class="authenticated && hasActiveSubscription ? '' : 'blur'"
        ></products-listing-row>
      </template>

      <pagination-item
        :items="products"
        :page="page"
        @changePage="
          $emit('update:page', $event)
          $emit('changePage')
        "
      ></pagination-item>
    </template>
    <div v-else class="empty-results">
      <slot>Aucun résultat disponible pour cette recherche.</slot>
    </div>
  </div>
</template>

<script>
import PaginationItem from '@/components/PaginationItem'
import ProductsListingRow from '@/components/ProductsListingRow'
import SubscriptionAdCard from './SubscriptionAdCard.vue'

export default {
  name: 'ProductsListing',
  components: { PaginationItem, ProductsListingRow, SubscriptionAdCard },

  props: {
    products: Object,
    page: Number,
    routeNameToDetail: String,
    favorite: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    authenticated () {
      return this.$store.getters['authent/isAuthenticated']
    },

    hasActiveSubscription () {
      return this.$store.getters['authent/hasActiveSubscription']
    }
  }
}
</script>
